export default "__VITE_ASSET__Ywq9n7bI__"